const sharedFunctions = require('./dataGridPagerSharedFunctions');

module.exports = function (args) {
  var DCLG = window.DCLG || {};

  var $pagerElem = $('<div class="pager"/>');
  var $pagerElemControl = $('<div class="pager-controls"/>');
  var $next = sharedFunctions.getPagerButton("Next", args.pageIndex, args.pageCount);
  var $prev = sharedFunctions.getPagerButton("Prev", args.pageIndex, args.pageCount);
  var $pager = sharedFunctions.getPager(args.pageIndex, args.pageCount);


  // To fetch the most recent values:
  if ($('.pagination-summary').length) {
    $('.pagination-summary').text(args.pageCount ? `Showing page ${args.pageIndex} of ${args.pageCount}` : '');
  } else {
    var $summary = getPagerSummary(args.pageIndex, args.pageCount);
    $pagerElem.append($summary);
  }

  if (args.pageCount > 0) {
    $pagerElemControl.append($prev).append($pager).append($next);
    $pagerElem.append($pagerElemControl);
  }
  
  DCLG.pageCount = args.pageCount;
  window.DCLG = DCLG;

  return $pagerElem;

  function getPagerSummary(currentPageNumber, pageCount) {
    var $pagerSummary = $('<div class="pager-summary"/>');
    var $records =
      "Showing page " +
      '<span class="pager-start">' +
      currentPageNumber +
      "</span>" +
      " of " +
      '<span class="pager-total">' +
      pageCount +
      "</span> " +
      "pages";

    return $pagerSummary.append($records);
  }
};
